// src/pages/Solicitacoes/components/SolicitacoesModal.jsx
import React, {useState, useEffect} from 'react';
import {Autocomplete, TextField, InputAdornment} from '@mui/material';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    MenuItem,
    Tabs,
    Tab,
    Typography,
    Box,
    Paper as MuiPaper,
    FormControlLabel,
    Checkbox,
    Backdrop,
    CircularProgress,
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close';
import {getUserInfoFornecedor} from '../../../services/GetUserInfoFornecedor';
import {
    geraInsumos,
    enviarAnexoNotaPagamento,
    fetchTabelaPrecoCompras,
    alteraInsumosOS,
} from '../../../services/easyhubQueries';
import {NumberFormatCustom} from '../../../tools/NumberFormatCustom';

export default function SolicitacoesModal({
    open,
    onClose,
    mode,
    currentNota,
    agreeToClose,
    setAgreeToClose,
    tabIndex,
    setTabIndex,
    selectedFotos,
    selectedNfs,
    handleFotosChange,
    handleNfsChange,
    handleSubmit,
    handleExcluirAnexo,
    reloadData,
}) {
    const [insumoForm, setInsumoForm] = useState({
        // TipoInsumo: '',
        CodInsumo: '',
        Qtd: '',
        VlrUnit: '',
        VlrTotal: '',
        // Destino: '',
    });
    const [produtos, setProdutos] = useState([]); // tabela 09
    const [unitMedida, setUnitMedida] = useState(''); // mostra B1_UM
    const [priceLocked, setPriceLocked] = useState(false); // bloqueia if preço existe
    const [submitting, setSubmitting] = useState(false);
    const handleChange = (f) => (e) => setInsumoForm((p) => ({...p, [f]: e.target.value}));
    // recalcula total sempre que quantidade ou unitário mudam
    useEffect(() => {
        const q = parseFloat(insumoForm.Qtd) || 0;
        const u = parseFloat(insumoForm.VlrUnit) || 0;
        setInsumoForm((p) => ({...p, VlrTotal: (q * u).toFixed(2)}));
    }, [insumoForm.Qtd, insumoForm.VlrUnit]);

    // carrega tabela de preços (query 09) só no abrir do modal de adicionarItem
    useEffect(() => {
        if (mode === 'adicionarItem') {
            fetchTabelaPrecoCompras()
                .then((resp) => {
                    if (resp.Retorno === 'OK' && Array.isArray(resp.Dados)) {
                        setProdutos(resp.Dados);
                    }
                })
                .catch(console.error);
        }
    }, [mode]);

    // ─── quando abrir em modo 'alterar', pré-popula o form ───
    useEffect(() => {
        if (mode === 'alterar' && currentNota) {
            const uni = parseFloat(currentNota.valorUnitario ?? currentNota.valorOrcamento) || 0;
            const qtd = parseFloat(currentNota.quantidade) || 0;
            setInsumoForm({
                CodInsumo: currentNota.codigo,
                Qtd: currentNota.quantidade,
                VlrUnit: uni.toFixed(2),
                VlrTotal: (qtd * uni).toFixed(2),
                Destino: '',
            });
            +(
                // ─── busca na tabela de preços se existe preço > 0 ───
                fetchTabelaPrecoCompras()
                    .then((resp) => {
                        if (resp.Retorno === 'OK' && Array.isArray(resp.Dados)) {
                            // procura o item na resposta
                            const prod = resp.Dados.find(
                                (item) => item.AIB_CODPRO === currentNota.codigo,
                            );
                            const preco = Number(prod?.AIB_PRCCOM ?? 0);
                            // se não achou OU preço > 0 → bloqueia edição
                            setPriceLocked(!(prod && preco === 0));
                        }
                    })
                    .catch(console.error)
            );
        }
    }, [mode, currentNota]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {
                    {
                        alterar: currentNota && `Alterar insumo ${currentNota.descricao}`,
                        anexarNotaFiscal:
                            currentNota && `Anexar Nota Fiscal para OS ${currentNota.numeroOS}`,
                        anexarNotaFiscalGrupo: `Anexar NF à OS ${currentNota?.numeroOS}`,
                        encerrar: currentNota && `Encerrar ${currentNota.numeroOS}`,
                        anexarArquivos:
                            currentNota && `Anexar arquivos para ${currentNota.numeroOS}`,
                        anexarFotos: currentNota && `Anexar fotos para ${currentNota.numeroOS}`,
                        anexarNfs:
                            currentNota && `Incluir notas fiscais para ${currentNota.numeroOS}`,
                        anexarImagens:
                            currentNota && `Incluir imagens para ${currentNota.numeroOS}`,
                        verAnexo: currentNota && `Anexos da OS ${currentNota.numeroOS}`,
                    }[mode]
                }
            </DialogTitle>

            <DialogContent dividers>
                {mode === 'encerrar' ? (
                    <MuiPaper
                        elevation={1}
                        sx={{
                            p: 2,
                            mb: 2,
                            borderRadius: 2,
                            bgcolor: 'background.paper',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        <Typography sx={{color: 'text.secondary'}}>
                            O status será alterado para <strong>Encerrado</strong> após envio.
                        </Typography>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={agreeToClose}
                                    onChange={(e) => setAgreeToClose(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Concordo e desejo encerrar esta OS"
                        />
                    </MuiPaper>
                ) : mode === 'verAnexo' && currentNota ? (
                    <>
                        <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} sx={{mb: 2}}>
                            <Tab label={`Imagens (${currentNota.fotosAnexadas.length})`} />
                            <Tab label={`Notas fiscais (${currentNota.nfsAnexadas.length})`} />
                        </Tabs>

                        {tabIndex === 0 ? (
                            currentNota.fotosAnexadas.length ? (
                                currentNota.fotosAnexadas.map((foto) => (
                                    <Box
                                        key={foto.id}
                                        sx={{display: 'flex', alignItems: 'center', mb: 2, gap: 2}}
                                    >
                                        <img
                                            src={foto.url}
                                            alt={foto.nome}
                                            style={{maxWidth: 100, borderRadius: 4}}
                                        />
                                        <Typography noWrap sx={{flex: 1}}>
                                            {foto.nome}
                                        </Typography>
                                        <Button
                                            color="error"
                                            size="small"
                                            startIcon={<CloseIcon />}
                                            onClick={() => handleExcluirAnexo('foto', foto.id)}
                                        >
                                            Excluir
                                        </Button>
                                    </Box>
                                ))
                            ) : (
                                <Typography>Nenhuma imagem anexada.</Typography>
                            )
                        ) : currentNota.nfsAnexadas.length ? (
                            currentNota.nfsAnexadas.map((nf) => (
                                <Box
                                    key={nf.id}
                                    sx={{display: 'flex', alignItems: 'center', mb: 2, gap: 2}}
                                >
                                    <a
                                        href={nf.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{flex: 1}}
                                    >
                                        {nf.nome}
                                    </a>
                                    <Button
                                        color="error"
                                        size="small"
                                        startIcon={<CloseIcon />}
                                        onClick={() => handleExcluirAnexo('nf', nf.id)}
                                    >
                                        Excluir
                                    </Button>
                                </Box>
                            ))
                        ) : (
                            <Typography>Nenhuma nota fiscal anexada.</Typography>
                        )}
                    </>
                ) : (
                    <>
                        {/* ─────────────── ALTERAR INSUMO ─────────────── */}
                        {mode === 'alterar' && (
                            <>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Código"
                                            value={insumoForm.CodInsumo}
                                            InputProps={{readOnly: true}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Qtd"
                                            type="text"
                                            inputProps={{
                                                inputMode: 'decimal',
                                                pattern: '\\d*(\\.\\d{0,2})?',
                                            }}
                                            value={insumoForm.Qtd}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // só atualiza se combinar com regex de até 2 decimais
                                                const re = /^\d*(?:\.\d{0,2})?$/;
                                                if (re.test(val)) {
                                                    setInsumoForm((prev) => ({...prev, Qtd: val}));
                                                }
                                            }}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Vlr Unitário"
                                            name="VlrUnit"
                                            value={insumoForm.VlrUnit}
                                            onChange={handleChange('VlrUnit')}
                                            fullWidth
                                            InputProps={{
                                                // aqui você já pode usar priceLocked se quiser travar, ou deixar sempre false
                                                readOnly: priceLocked,
                                                inputComponent: NumberFormatCustom,
                                                inputProps: {
                                                    onFocus: () => {
                                                        const val =
                                                            parseFloat(insumoForm.VlrUnit) || 0;
                                                        if (!priceLocked && val === 0) {
                                                            setInsumoForm((prev) => ({
                                                                ...prev,
                                                                VlrUnit: '',
                                                                // VlrTotal: ''   // descomente se quiser zerar o total também
                                                            }));
                                                        }
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Total"
                                            name="VlrTotal"
                                            value={insumoForm.VlrTotal}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                inputComponent: NumberFormatCustom,
                                            }}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <TextField
                                            select
                                            label="Destino"
                                            value={insumoForm.Destino}
                                            onChange={handleChange('Destino')}
                                            fullWidth
                                        >
                                            <MenuItem value="A">Apoio</MenuItem>
                                            <MenuItem value="S">Substituição</MenuItem>
                                            <MenuItem value="T">Troca</MenuItem>
                                        </TextField>
                                    </Grid> */}
                                </Grid>
                            </>
                        )}
                        {/* ───────────── ADICIONAR ITEM EXISTENTE ───────────── */}
                        {mode === 'anexarNotaFiscal' ||
                            (mode === 'anexarNotaFiscalGrupo' && (
                                <>
                                    <Typography sx={{mb: 1}}>Selecione o arquivo:</Typography>
                                    <Button variant="contained" component="label">
                                        {' '}
                                        Selecionar Arquivos
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            accept=".pdf,image/*"
                                            onChange={handleNfsChange}
                                        />
                                    </Button>
                                    {selectedNfs.length > 0 && (
                                        <Typography sx={{mt: 1}}>
                                            {selectedNfs.length} arquivo(s) selecionado(s)
                                        </Typography>
                                    )}
                                </>
                            ))}
                        {(mode === 'anexarFotos' ||
                            mode === 'anexarImagens' ||
                            mode === 'anexarArquivos') && (
                            <>
                                <Typography sx={{mb: 1}}>Fotos da avaria corrigida:</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<PhotoCamera />}
                                >
                                    Selecionar Fotos
                                    <input
                                        type="file"
                                        hidden
                                        multiple
                                        accept="image/*"
                                        onChange={handleFotosChange}
                                    />
                                </Button>
                                {selectedFotos.length > 0 && (
                                    <Typography sx={{mt: 1}}>
                                        {selectedFotos.length} arquivo(s) selecionado(s)
                                    </Typography>
                                )}
                            </>
                        )}
                        {/* {(mode === 'anexarNfs' || mode === 'anexarArquivos') && (
                            <>
                                <Typography sx={{mt: 3, mb: 1}}>Notas fiscais (NFs):</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<PhotoCamera />}
                                >
                                    Selecionar NFs
                                    <input
                                        type="file"
                                        hidden
                                        multiple
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={handleNfsChange}
                                    />
                                </Button>
                                {selectedNfs.length > 0 && (
                                    <Typography sx={{mt: 1}}>
                                        {selectedNfs.length} arquivo(s) selecionado(s)
                                    </Typography>
                                )}
                            </>
                        )}{' '} */}
                        {mode === 'adicionarItem' && (
                            <>
                                <Typography variant="h6" gutterBottom>
                                    Novo insumo para OS {currentNota.numeroOS}
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Autocomplete
                                            options={produtos}
                                            getOptionLabel={(opt) =>
                                                `${opt.AIB_CODPRO} – ${opt.B1_DESC}`
                                            }
                                            onChange={(_, value) => {
                                                if (value) {
                                                    const preco = Number(value.AIB_PRCCOM) || 0;
                                                    setInsumoForm((p) => ({
                                                        ...p,
                                                        CodInsumo: value.AIB_CODPRO,
                                                        VlrUnit: preco.toFixed(2),
                                                    }));
                                                    setUnitMedida(value.B1_UM);
                                                    setPriceLocked(preco > 0);
                                                } else {
                                                    // limpou a seleção → libera edição e limpa valor
                                                    setPriceLocked(false);
                                                    setUnitMedida('');
                                                    setInsumoForm((p) => ({...p, VlrUnit: ''}));
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Código ou Descrição"
                                                    fullWidth
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Qtd"
                                            type="text"
                                            inputProps={{
                                                inputMode: 'decimal',
                                                pattern: '\\d*(\\.\\d{0,2})?',
                                            }}
                                            value={insumoForm.Qtd}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // só atualiza se combinar com regex de até 2 decimais
                                                const re = /^\d*(?:\.\d{0,2})?$/;
                                                if (re.test(val)) {
                                                    setInsumoForm((prev) => ({...prev, Qtd: val}));
                                                }
                                            }}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Vlr Unitário"
                                            name="VlrUnit"
                                            value={insumoForm.VlrUnit}
                                            onChange={handleChange('VlrUnit')}
                                            fullWidth
                                            InputProps={{
                                                readOnly: priceLocked,
                                                inputComponent: NumberFormatCustom,
                                                onFocus: () => {
                                                    const val = parseFloat(insumoForm.VlrUnit) || 0;
                                                    // só limpa se não estiver travado E o valor for zero
                                                    if (!priceLocked && val === 0) {
                                                        setInsumoForm((prev) => ({
                                                            ...prev,
                                                            VlrUnit: '', // limpa unitário
                                                            // VlrTotal: ''   // opcional: limpa também total se quiser
                                                        }));
                                                    }
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Unidade"
                                            value={unitMedida}
                                            InputProps={{readOnly: true}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Total"
                                            name="VlrTotal"
                                            value={insumoForm.VlrTotal}
                                            InputProps={{
                                                readOnly: true,
                                                inputComponent: NumberFormatCustom,
                                            }}
                                            fullWidth
                                        />
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <TextField
                                            select
                                            label="Destino"
                                            value={insumoForm.Destino}
                                            onChange={handleChange('Destino')}
                                            fullWidth
                                        >
                                            <MenuItem value="A">Apoio</MenuItem>
                                            <MenuItem value="S">Substituição</MenuItem>
                                            <MenuItem value="T">Troca</MenuItem>
                                        </TextField>
                                    </Grid>{' '} */}
                                </Grid>
                            </>
                        )}
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                {mode === 'alterar' ? (
                    <Button
                        variant="contained"
                        disabled={
                            !insumoForm.CodInsumo ||
                            !insumoForm.Qtd ||
                            !insumoForm.VlrUnit ||
                            submitting
                        }
                        endIcon={submitting ? <CircularProgress size={18} /> : null}
                        onClick={async () => {
                            try {
                                setSubmitting(true);
                                await alteraInsumosOS(currentNota.numeroOS, [
                                    {
                                        produto: insumoForm.CodInsumo,
                                        qtd: insumoForm.Qtd,
                                        valor_uni: insumoForm.VlrUnit,
                                        seq_tar: currentNota.seqTar,
                                    },
                                ]);
                                reloadData();
                                onClose();
                            } catch (e) {
                                console.error(e);
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                    >
                        Salvar Alteração
                    </Button>
                ) : mode === 'adicionarItem' ? (
                    <Button
                        variant="contained"
                        disabled={Object.values(insumoForm).some((v) => !v) || submitting}
                        endIcon={submitting ? <CircularProgress size={18} /> : null}
                        onClick={async () => {
                            try {
                                setSubmitting(true);
                                const auth = getUserInfoFornecedor();
                                // injeta automaticamente nos dados do item
                                const payload = {
                                    TipoInsumo: 'P',
                                    ...insumoForm,
                                    CodForn: auth.cod_cli,
                                    LojForn: auth.loj_cli,
                                };
                                await geraInsumos(currentNota.numeroOS, [payload]);
                                reloadData(); // recarrega a lista de ordens
                                onClose();
                            } catch (e) {
                                console.error(e);
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                    >
                        {submitting ? 'Adicionando…' : 'Adicionar Item'}
                    </Button>
                ) : (
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={
                            (mode === 'anexarNotaFiscal' || mode === 'anexarNotaFiscalGrupo') &&
                            selectedNfs.length === 0
                        }
                    >
                        {mode === 'encerrar'
                            ? 'Encerrar e Enviar'
                            : mode === 'anexarNotaFiscalGrupo' || mode === 'anexarNotaFiscal'
                              ? 'Enviar'
                              : 'Enviar'}
                    </Button>
                )}
            </DialogActions>
            {/* Overlay de loading para bloquear cliques durante o envio */}
            <Backdrop open={submitting} sx={{zIndex: (theme) => theme.zIndex.modal + 1}}>
                <CircularProgress />
            </Backdrop>
        </Dialog>
    );
}
